module.exports = __webpack_public_path__ + "static/img/1-1Z52F94634359.c78d990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z52F94634359.png
// module id = Ad5U
// module chunks = 0